import React from 'react';

const AgendaIco = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 512 512">
      <path d="M481.3,38H431v71.8c0,23.5-18,42.2-40.6,42.2h-12.8c-22.6,0-40.6-18.8-40.6-42.2V38H183v71.8c0,23.5-18.3,42.2-40.9,42.2
h-12.8c-22.6,0-41.3-18.8-41.3-42.2V38H30.7C13.8,38,0,52.8,0,70.3v409.8C0,497.6,13.8,512,30.7,512h450.6
c16.9,0,30.7-14.4,30.7-31.9V70.3C512,52.8,498.2,38,481.3,38z M160,428.2c0,6.5-5.3,11.8-11.8,11.8l0,0H81.8
c-6.5,0-11.8-5.3-11.8-11.8l0,0v-52.5c0-6.5,5.3-11.8,11.8-11.8l0,0h66.5c6.5,0,11.8,5.3,11.8,11.8l0,0V428.2z M160,301.2
c0,6.5-5.3,11.8-11.8,11.8l0,0H81.8c-6.5,0-11.8-5.3-11.8-11.8l0,0v-52.5c0-6.5,5.3-11.8,11.8-11.8l0,0h66.5
c6.5,0,11.8,5.3,11.8,11.8l0,0V301.2z M301,428.2c0,6.5-5.3,11.8-11.8,11.8l0,0h-66.5c-6.5,0-11.8-5.3-11.8-11.8l0,0v-52.5
c0-6.5,5.3-11.8,11.8-11.8l0,0h66.5c6.5,0,11.8,5.3,11.8,11.8l0,0V428.2z M301,301.2c0,6.5-5.3,11.8-11.8,11.8l0,0h-66.5
c-6.5,0-11.8-5.3-11.8-11.8l0,0v-52.5c0-6.5,5.3-11.8,11.8-11.8l0,0h66.5c6.5,0,11.8,5.3,11.8,11.8l0,0V301.2z M445,428.2
c0,6.5-5.3,11.8-11.8,11.8l0,0h-66.5c-6.5,0-11.8-5.3-11.8-11.8l0,0v-52.5c0-6.5,5.3-11.8,11.8-11.8l0,0h66.5
c6.5,0,11.8,5.3,11.8,11.8l0,0V428.2z M445,301.2c0,6.5-5.3,11.8-11.8,11.8l0,0h-66.5c-6.5,0-11.8-5.3-11.8-11.8l0,0v-52.5
c0-6.5,5.3-11.8,11.8-11.8l0,0h66.5c6.5,0,11.8,5.3,11.8,11.8l0,0V301.2z"/>
      <path d="M142.1,134c12.7,0,22.9-11,22.9-24.2V24c0-13.2-10.2-24-22.9-24h-12.8C116.6,0,106,10.7,106,24v85.8
c0,13.2,10.6,24.2,23.3,24.2H142.1z"/>
      <path d="M390.4,134c12.7,0,22.6-11,22.6-24.2V23.9C413,10.7,403.1,0,390.4,0h-12.8C364.9,0,355,10.7,355,23.9v85.8
c0,13.2,9.9,24.2,22.6,24.2H390.4z"/>
    </svg>

  )
}

export default AgendaIco;